/* istanbul ignore file */
export const tpgWidgetInit = () => {
  window.zESettings = {
    webWidget: {
      chat: {
        departments: {
          enabled: [],
        },
      },
    },
  };

  window.zESettings = {
    webWidget: {
      launcher: {
        chatLabel: {
          "*": "Contact Us",
        },
        label: {
          "*": "Contact Us",
        },
      },
      chat: {
        departments: {
          enabled: [],
        },
      },
    },
  };
};
